export default "__VITE_ASSET__LYBt8BLe__"